"use client";

import { Button } from "@oreme/ui";
import { ExternalLink } from "lucide-react";
import Link from "next/link";
import { useLocale } from "next-intl";
import React, { Fragment, type ReactElement } from "react";
import { Tag } from "@/types";

interface GlossaryDefinitionListProps {
  tags: Tag[];
}

function GlossaryDefinitionList({
  tags,
}: Readonly<GlossaryDefinitionListProps>): ReactElement {
  const locale = useLocale();

  return (
    <dl className="glossary-definition-list grid grid-cols-1 md:grid-cols-3 gap-4 py-4">
      {tags.map((tag: Tag): ReactElement => {
        const name = tag.name[locale];
        const description = tag.description[locale];
        const source = tag.source[locale];
        return (
          <Fragment key={tag.id}>
            <dt className="title font-semibold m-0 rounded-t-lg md:rounded-l-lg">
              {name}
            </dt>
            <dd className="description col-span-2 text-muted-foreground text-xs rounded-b-lg md:rounded-r-lg md:text-sm leading-tight -mt-2 md:mt-0">
              {description}
              {source ? (
                <div className="flex justify-end items-end mt-2">
                  <Link href={source} target="_blank">
                    <Button variant="secondary" size="xs">
                      Source <ExternalLink size={16} strokeWidth={1} />
                    </Button>
                  </Link>
                </div>
              ) : null}
            </dd>
          </Fragment>
        );
      })}
    </dl>
  );
}

export { GlossaryDefinitionList, type GlossaryDefinitionListProps };
